import type { RuleSet } from "styled-components";
import tw, { styled, type TwStyle } from "twin.macro";

export const StyledWrapperDetailAmount = styled.div<{ $classes?: RuleSet<object> | TwStyle }>`
  ${tw`w-full flex flex-col gap-xxs`}
  ${({ $classes }) => $classes && $classes}
`;
